import type { ComponentType } from 'react';
import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getUserInfo, UserContext } from '../../contexts';
import { allPaths } from '../../routes/Paths';
import type { PlainObject } from 'simplytyped';
import { ChallengeNames } from '../../common/types/Authentication';
import toast from 'react-hot-toast';

const withNoAuthRedirect =
  <Props extends PlainObject>(Component: ComponentType<Props>) =>
  (props: Props & { currentPage?: string }) => {
    const { pathname } = useLocation();
    const { loginData, user, userInfo, logOut, setMerchantServiceUserInfo } =
      useContext(UserContext);

    if (
      pathname !== allPaths.SMS_VERIFICATION.path &&
      loginData.challengeName === ChallengeNames.SMS
    ) {
      return <Navigate replace to={allPaths.SMS_VERIFICATION.path} />;
    }

    if (
      !pathname.includes(allPaths.CONFIRM_RESET_PASSWORD.path) &&
      loginData.challengeName === ChallengeNames.NEW_PASSWORD_REQUIRED
    ) {
      return (
        <Navigate
          replace
          to={`${allPaths.CONFIRM_RESET_PASSWORD.path}?set-initial-password=true`}
        />
      );
    }

    if (
      (pathname !== allPaths.LOGIN.path &&
        !loginData.session &&
        user.userType === 'unknown') ||
      !user
    ) {
      logOut();
      return <Navigate replace to={allPaths.LOGIN.path} />;
    }

    if (user.userType === 'platformAdmin' || user.userType === 'platformUser') {
      return <Navigate replace to={allPaths.ACCOUNTS.path} />;
    }
    if (user.userType !== 'unknown') {
      // console.log('user.sub:', user.sub);
      if (userInfo.userId === 'NOT_SIGNED_IN') {
        getUserInfo(user.sub).then((userInfo) => {
          // console.log('userInfo', userInfo);
          if (userInfo) {
            // console.log(
            //   '___userInfo: setMerchantServiceUserInfo noAuthRedirect'
            // );
            setMerchantServiceUserInfo(userInfo);
            return <Navigate replace to={allPaths.APPLICATIONS.path} />;
          } else {
            toast.error(
              'There was a problem getting your details, contact support'
            );
            logOut();
            return <Navigate replace to={allPaths.LOGIN.path} />;
          }
        });
      } else {
        return <Navigate replace to={allPaths.APPLICATIONS.path} />;
      }
    }

    return <Component {...props} />;
  };

export { withNoAuthRedirect };
